/**
 * Created by tombray on 12/19/14.
 */

export default function(user) {
    const first = user.first_name || "Unknown";
    const last = user.last_name || "Unknown";
    return first + " " + last;
}
